export default __webpack_public_path__ + "static/media/header-online-course-icon.58f1d9f6.svg";